export default __webpack_public_path__ + "static/media/capri3.9bf5827f.png";